export const PERMISSIONS = {
  // User management
  USER_CREATE: 'user:create',
  USER_READ: 'user:read',
  USER_UPDATE: 'user:update',
  USER_DELETE: 'user:delete',
  USER_LIST: 'user:list',
  USER_ASSIGN_ROLE: 'user:assign_role',
  
  // Pirate Call
  PIRATECALL_QUERY: 'piratecall:query',
  PIRATECALL_QUERY_GSM: 'piratecall:query_gsm',
  PIRATECALL_QUERY_ADDRESS: 'piratecall:query_address',
  PIRATECALL_QUERY_SGK: 'piratecall:query_sgk',
  PIRATECALL_QUERY_RELATIONSHIPS: 'piratecall:query_relationships',
  PIRATECALL_QUERY_HELPERS: 'piratecall:query_helpers',
  
  // Server
  SERVER_VIEW_UTILIZATION: 'server:view_utilization',
  SERVER_VIEW_LOGS: 'server:view_logs',
  SERVER_MANAGE_SYSTEM: 'server:manage_system',
  // Contact
  CONTACT_MANAGEMENT: 'contact_management',
  
  // Blog
  BLOG: {
    READ: 'blog:read',
    MANAGE: 'blog:manage'
  }
};

export const ROLES = {
  ROOT: 'root',
  ADMIN: 'admin',
  USER: 'user',
  GUEST: 'guest'
};
